import { render, staticRenderFns } from "./menuCard.vue?vue&type=template&id=5dcf70d5&scoped=true&"
import script from "./menuCard.vue?vue&type=script&lang=js&"
export * from "./menuCard.vue?vue&type=script&lang=js&"
import style0 from "./menuCard.vue?vue&type=style&index=0&id=5dcf70d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcf70d5",
  null
  
)

export default component.exports